import { useContext } from 'react';

import { InvestorAccountsContext } from './context';

export const useInvestorAccounts = () => {
  return useContext(InvestorAccountsContext);
};
